import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import ReactSelect from 'react-select';

const CompletionInfo = () => {
  const { id } = useParams();
  const [city, setCity] = useState(null);
  const [completionDate, setCompletionDate] = useState();
  const [donationCurrency, setDonationCurrency] = useState(1);

  const cityOptions = [
    { value: '1', label: 'Mogadishu' },
    { value: '2', label: 'Nairobi' },
    { value: '3', label: 'Ruiru' },
    { value: '4', label: 'Karachi' }
  ];

  const donationCurrencyData = [
    { value: '1', label: 'USD' },
    { value: '2', label: 'PR' },
    { value: '3', label: 'EUR' }
  ];

  return (
    <Card className="mb-3">
      <FalconCardHeader
        title={
          <h4 className="mt-2 fw-bold">
            <FontAwesomeIcon icon={'ticket-alt'} className="me-2" />
            Project Completion{' '}
          </h4>
        }
        light={false}
        titleTag="div"
        menuClassName="align-items-center"
        endEl={<p className="mb-0 test-600">#{id}</p>}
      />
      <Card.Body className="pt-0">
        <Row className="g-3">
          <Form.Group as={Col} md={6}>
            <Form.Label>
              Completion Date <span className="text-danger">*</span>
            </Form.Label>
            <DatePicker
              selected={completionDate}
              onChange={date => setCompletionDate(date)}
              className="form-control"
              placeholderText="DD/MM/YYYY"
              timeIntervals={5}
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              fixedHeight
            />
          </Form.Group>
          <Form.Group as={Col} md={6}>
            <Form.Label>
              Cities <span className="text-danger">*</span>
            </Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={cityOptions}
              placeholder="Select"
              classNamePrefix="react-select"
              className="we-raise"
              isMulti
              value={city}
              onChange={value => setCity(value)}
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="Number of Beneficiaries">
            <Form.Label>
              Number of Beneficiaries <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              required
              type="number"
              placeholder="Number of Beneficiaries"
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={6}>
            <Form.Label>
              Currency <span className="text-danger">*</span>
            </Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={donationCurrencyData}
              placeholder="Select"
              classNamePrefix="react-select"
              value={donationCurrency}
              onChange={value => setDonationCurrency(value)}
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="Total Project Cost">
            <Form.Label>
              Total Project Cost <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              required
              type="number"
              placeholder="Total Project Cost"
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="6" controlId="Total Administration Cost">
            <Form.Label>
              Total Administration Cost <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              required
              type="number"
              placeholder="Total Administration Cost"
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CompletionInfo;
